import React from 'react';

import classes from './CharsCounter.module.scss';

interface Props {
    current: number;
    max: number;
}

export const CharsCounter = ({ current, max }: Props) => {
    return (
        <div className={classes.charsCounter}>
            <div className={classes.counter}>
                {current} / {max}
            </div>
        </div>
    );
};
